import React from 'react'

export default function MobileOutline({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'

    return (
        <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            style={style}
        >
            <path
                d='M11.3334 1.33333H4.66671C3.93033 1.33333 3.33337 1.93028 3.33337 2.66666V13.3333C3.33337 14.0697 3.93033 14.6667 4.66671 14.6667H11.3334C12.0698 14.6667 12.6667 14.0697 12.6667 13.3333V2.66666C12.6667 1.93028 12.0698 1.33333 11.3334 1.33333Z'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path d='M8 12H8.00667' stroke='#525150' strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    )
}
